<template>
    <div class="ls-non-mowing-form--container">
        <form @submit.prevent="submitNowMowingForm">
            <ls-panel
                class="ls-border-all ls-border-bottom-none ls-non-mowing-form--service-details"
            >
                <LsCustomerLeads
                    v-if="customerLeadsEnabled"
                    ref="customerLeads"
                    @onLawnMowingClick="goBack"
                >
                    <a
                        :class="{
                            'ls-button': true,
                            'll-button-primary': isLawnLove,
                            'ls-button--yellow': isLawnStarter,
                        }"
                        style="width: 75px;"
                        @click.prevent="goBack"
                    >
                        <i class="fa fa-arrow-circle-left"></i>
                        <span>&nbsp;Back</span>
                    </a>
                    <h2
                        class="ls-align--center ls-condensed"
                        :class="{ 'ls-margin--bottom ls-margin--top': screenSize.xs }"
                    >
                        Get Free Quotes from Highly Rated Pros
                    </h2>
                    <p class="ls-align--center" data-font-size="-1" style="margin-top: 3px;">
                        <span>Fill in the below details to get free quotes from pros.</span>
                    </p>
                    <hr />
                </LsCustomerLeads>
                <LsOrderServiceLead v-else ref="orderServiceLead">
                    <a
                        :class="{
                            'ls-button': true,
                            'll-button-primary': isLawnLove,
                            'ls-button--yellow': isLawnStarter,
                        }"
                        style="width: 75px;"
                        @click.prevent="goBack"
                    >
                        <i class="fa fa-arrow-circle-left"></i>
                        <span>&nbsp;Back</span>
                    </a>
                    <h2
                        class="ls-align--center ls-condensed section-title"
                        :class="{ 'ls-margin--bottom ls-margin--top': screenSize.xs }"
                    >
                        Request a Quote for Specialty Services
                    </h2>
                    <p class="ls-align--center" data-font-size="-1" style="margin-top: 3px;">
                        <span>We'll be in touch via phone or email</span>
                    </p>
                    <hr />
                </LsOrderServiceLead>
            </ls-panel>

            <ls-panel class="ls-border-all ls-border-top-none ls-non-mowing-form--contact-details">
                <ls-contact-info :title="'How can we get in touch?'"></ls-contact-info>

                <div v-if="customerLeadsEnabled" class="grid">
                    <div class="grid__col-12 ls-margin--top">
                        <ls-tcpa-disclosure
                            v-if="customerLeadsEnabled"
                            submit-text="Submit"
                            track-click-target="non-mowing-customer-leads-form--open-tos-modal"
                        />
                    </div>
                </div>

                <ls-error></ls-error>

                <div slot="button" class="grid">
                    <div class="grid__col-12 ls-margin--top">
                        <button
                            v-if="customerLeadsEnabled"
                            v-ls-track.click="{
                                target: 'non-mowing-form--submit-button',
                            }"
                            :class="{
                                'ls-button ls-button--block ls-button--lg ls-margin--bottom': true,
                                'll-button-primary': isLawnLove,
                                'ls-button--yellow': isLawnStarter,
                            }"
                            type="submit"
                        >
                            <span v-if="customerLeads.loadingStatus.isUpdating"
                                ><i class="fa fa-pulse fa-spinner"></i>&nbsp;Submitting</span
                            >
                            <span v-else>Submit</span>
                        </button>
                        <button
                            v-else
                            v-ls-track.click="{
                                target: 'non-mowing-form--submit-button',
                            }"
                            :class="{
                                'ls-button ls-button--block ls-button--lg ls-margin--top': true,
                                'll-button-primary': isLawnLove,
                                'ls-button--yellow': isLawnStarter,
                            }"
                            type="submit"
                        >
                            <span v-if="orderServiceLead.loadingStatus.isUpdating"
                                ><i class="fa fa-pulse fa-spinner"></i>&nbsp;Requesting Quote</span
                            >
                            <span v-else>Request Quote</span>
                        </button>
                    </div>
                </div>
            </ls-panel>
        </form>
    </div>
</template>

<script>
import VueScrollTo from 'vue-scrollto';
import _ from 'lodash';
import { mapState, mapGetters, mapActions } from 'vuex';
import {
    SCREEN_SIZE__GET_MOBILE_SCREEN,
    SCREEN_SIZE__GET_DESKTOP_SCREEN,
    CUSTOMER_LEADS__SUBMIT,
    ORDER_SERVICE_LEAD__SUBMIT,
    MODAL__OPEN_MODAL,
} from '@/store/types';
import eventBusService from '@/services/event-bus.service';
import lsPanel from '@/components/original-mydot/panel/Panel.vue';
import LsOrderServiceLead from '@/components/original-mydot/order-service-lead/OrderServiceLead.vue';
import lsContactInfo from '@/components/original-mydot/contact-info/ContactInfo.vue';
import lsError from '@/components/original-mydot/error/Error.vue';
import brandMixin from '@/mixins/brand.mixin';
import initializeTrustedForm from '@/helpers/trusted-form';
import lsTcpaDisclosure from '@/components/original-mydot/landscaping-leads/TcpaDisclosure.vue';
import LsCustomerLeads from './LsCustomerLeads/LsCustomerLeads.vue';

export default {
    components: {
        lsPanel,
        LsOrderServiceLead,
        lsContactInfo,
        lsError,
        LsCustomerLeads,
        lsTcpaDisclosure,
    },
    mixins: [brandMixin],
    computed: {
        ...mapState(['contactInfo', 'customerLeads', 'order', 'orderServiceLead', 'screenSize']),
        ...mapGetters({
            mobile: SCREEN_SIZE__GET_MOBILE_SCREEN,
            desktop: SCREEN_SIZE__GET_DESKTOP_SCREEN,
        }),
        customerLeadsEnabled() {
            return this.order.customer_leads_enabled;
        },
    },
    created() {
        initializeTrustedForm();

        // Used in signup-web redirect
        this.fname = _.get(this.order, 'fname');
        this.lname = _.get(this.order, 'lname');
        this.phone = _.get(this.order, 'phone');
        this.address = _.get(this.order, 'address');
        this.intent = _.get(this.order, 'intent');
    },
    methods: {
        ...mapActions({
            customerLeadsSubmit: CUSTOMER_LEADS__SUBMIT,
            orderServiceLeadSubmit: ORDER_SERVICE_LEAD__SUBMIT,
            openModal: MODAL__OPEN_MODAL,
        }),
        async submitNowMowingForm() {
            let mainFormIsValid = null;
            if (this.customerLeadsEnabled) {
                mainFormIsValid = await this.$refs.customerLeads.checkFormValidation();
            } else {
                mainFormIsValid = this.$refs.orderServiceLead.checkFormValidation();
            }

            if (mainFormIsValid !== true || !this.contactInfo.valid) {
                eventBusService.eventBus.$emit('submitButtonClick');
                setTimeout(() => {
                    let firstInvalidInput = null;
                    const orderServiceLeadFirstElement = document.getElementsByClassName(
                        'ls-order-service-lead--invalid'
                    )[0];
                    const lsInvalidFirstElement = document.getElementsByClassName('ls-invalid')[0];

                    // because we have a mix of both classes on the orderServiceLead component, we'll need to detect which is higher on the page if both have an invalid item
                    if (orderServiceLeadFirstElement) {
                        if (lsInvalidFirstElement) {
                            firstInvalidInput =
                                orderServiceLeadFirstElement.getBoundingClientRect().top <
                                lsInvalidFirstElement.getBoundingClientRect().top
                                    ? orderServiceLeadFirstElement
                                    : lsInvalidFirstElement;
                        } else {
                            firstInvalidInput = orderServiceLeadFirstElement;
                        }
                    } else {
                        firstInvalidInput = lsInvalidFirstElement;
                    }

                    if (firstInvalidInput) {
                        const offset = this.screenSize.xs || this.screenSize.sm ? -150 : -105; // offset to account for the sticky header + the input label
                        VueScrollTo.scrollTo(firstInvalidInput, 500, { offset });
                    }
                });
            } else if (this.customerLeadsEnabled) {
                this.$refs.customerLeads.saveFormData();
                this.customerLeadsSubmit({
                    trusted_form_id: _.get(window, 'trustedForm.id'),
                    tcpa_text: _.get(
                        document.getElementsByClassName('tcpa-disclosure--text')[0],
                        'textContent',
                        ''
                    ),
                });
            } else {
                this.orderServiceLeadSubmit();
            }
        },
        redirectToSignupWeb() {
            const intentReferer = sessionStorage.getItem('intentReferer');
            const address = this.address
                ? `${this.address.street}, ${this.address.city}, ${this.address.state}, ${this.address.zip}, ${this.address.country}`
                : null;

            return `${document.referrer}cart/contact-info?intent=${intentReferer}&phone=${this.phone}&name=${this.fname}+${this.lname}&address=${address}`;
        },
        goBack() {
            if (document.referrer.match(new RegExp(/signup-web/))) {
                window.location.assign(this.redirectToSignupWeb());
                return;
            }

            this.$router.go(-1);
        },
    },
};
</script>

<style lang="scss" scoped>
.ls-non-mowing-form--container {
    margin-bottom: 100px; // scrolling to make bottom not feel like its getting cut off
}

.ls-non-mowing-form--tos-text {
    font-size: 14px;
    margin-top: 5px;
}

.themed-lawnlove {
    .ls-non-mowing-form--service-details {
        border-top-left-radius: 15px;
        border-top-right-radius: 15px;
    }

    .ls-non-mowing-form--contact-details {
        border-bottom-left-radius: 15px;
        border-bottom-right-radius: 15px;
    }

    @include max-screen(breakpoint(xs, max)) {
        .ls-non-mowing-form--service-details,
        .ls-non-mowing-form--contact-details {
            border-radius: 0;
        }
    }
}
</style>
